export const dump = (obj, depth = 2) => {
  return (
    <pre className="w-full overflow-scroll">
      {JSON.stringify(obj, null, depth)}
    </pre>
  )
}
